import React from 'react'
import { goodsModel, GoodsModel } from '../model'
import { useField } from 'formik'
import Input from '../../../../../../../../../../components/input/input'
import { Expaned, Row } from '@/components/layout/layout'
import { observer } from 'mobx-react'
import { getBEMCls } from '@/utils/classname'
import classNames from 'classnames'
import { showLayer } from '@/utils/layer'
import ChooseGoodsUnitDialog from '../goods-unit/goods-unit'

export const GoodsStockUnitFormItem: React.FC<{
    goodsModel: GoodsModel
}> = observer(props => {
    const cls = (...args: string[]) => getBEMCls('edit-goods', ...args)
    const [field, , helpers] = useField('stock_unit_id')
    const unitName = props.goodsModel.goodsUnit.find(val => val.id === field.value)?.name

    return (
        <Row data-align-items-center data-padding-h-24>
            <span data-color-999 data-font-weight-400 className={classNames(cls('form-item', 'title'))}></span>
            <Row data-align-items-center data-expaned>
                <Input
                    inputprefix={() => {
                        return <span className={classNames(cls('form-item', 'title'))}>库存单位</span>
                    }}
                    inputsuffix={() => {
                        return (
                            <Row
                                data-cursor-pointer
                                data-expaned
                                data-algin-items-center
                                onClick={() => {
                                    showLayer(
                                        <ChooseGoodsUnitDialog
                                            goodsModel={goodsModel}
                                            choosedId={field.value}
                                            onChange={params => {
                                                helpers.setValue(params.id)
                                            }}
                                        ></ChooseGoodsUnitDialog>,
                                    )
                                }}
                            >
                                <Expaned data-row data-algin-items-center>
                                    <span data-font-size-14 data-color-000>
                                        元/{unitName}
                                    </span>
                                </Expaned>
                                <i className="iconfont icon6xiala2-202"></i>
                            </Row>
                        )
                    }}
                    // 设置内部input display none
                    style={{ display: 'none' }}
                ></Input>
            </Row>
        </Row>
    )
})
